import { defineStore } from 'pinia';
import { ref } from 'vue';

export type SortDirection = 'asc' | 'desc' | null;

export type Sort = {
    key: string | null;
    direction: SortDirection;
};

export const useSortingStore = (key: string = 'default') =>
    defineStore(key + '-sorting', () => {
        const currentSort = ref<Sort>({
            key: null,
            direction: null,
        });

        function setSort(key: string, direction: SortDirection = 'asc') {
            if (currentSort.value.key === key) {
                currentSort.value.direction = currentSort.value.direction === 'asc' ? 'desc' : 'asc';
            } else {
                currentSort.value = {
                    key,
                    direction,
                };
            }
        }

        function isSortingOn(key: string): boolean {
            return currentSort.value.key === key;
        }

        return { currentSort, setSort, isSortingOn };
    })();
